import React, { useEffect, useMemo, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import { domain, Context } from '../../config';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { OurFocusAnimation } from '../../components/animations';
import { LayoutOurFocusState } from "../../store/ducks/our_focus/types";
import { State } from "../../types";
import { ourFocus } from "../../store/ducks/our_focus/actions";

const Our_Focus = () => {
	const { siteDomain, locale } = useContext(Context);
    const startText = useRef();
    const portfolioRef = useRef();
	const dispatch = useDispatch();
	const our_focus: LayoutOurFocusState = useSelector((state: State) => state.our_focus.data);
	const status: string = useSelector((state: State) => state.our_focus.status);

	useEffect(() => {
		if (status === 'IDLE') {
			dispatch(ourFocus(locale));
		}
	}, []);

    useEffect(() => {
        setTimeout(() => {
            startText.current.classList.add("_active");
        }, 100);
    }, []);

	return (
		<>
			<Helmet>
				<title>{our_focus.titleOurFocus}</title>
				<meta
					property="og:title"
					content={`${our_focus.titleOurFocus}`}
				/>
				<meta
					property="twitter:title"
					content={`${our_focus.titleOurFocus}`}
				/>
				<meta
					name="description"
					content={``}
				/>
				<meta
					property="og:description"
					content={``}
				/>
				<meta
					property="twitter:description"
					content={``}
				/>
				<meta property="og:image" content={`${siteDomain}/img/overbest_og_en.png`} />
                <meta property="og:url" content={`${siteDomain}/our_focus`} />
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>

			<main className="page-our-focus">
                {portfolioRef &&
                    <OurFocusAnimation
                        portfolioRef={portfolioRef}
                    />
                }
				<section className="screen page-our-focus__screen">
					<div className="screen__container">
						<h1
                            className="screen__title title title--white"
                            ref={startText}
                        >
                            {our_focus.titleOurFocus}
                        </h1>
					</div>
					{our_focus.steps.length > 0 && our_focus.steps.map(step => (
						<div key={step.key} className="screen__container">
							<span className="screen__number title">{step.number}</span>
							<h2 className="screen__name smallTitle smallTitle--white">{step.title}</h2>
							<p className="screen__text text--white" dangerouslySetInnerHTML={{ __html: step.description }} />
							{step.steps.length > 0 && (
								<ul className="screen-list screen__screen-list">
									{step.steps.map(item => (
										<li key={item.key} className="screen-list__item">
											<span className="screen-list__number smallTitle smallTitle--white">{item.number}</span>
											<p className="screen-list__text smallText" dangerouslySetInnerHTML={{ __html: item.description }} />
										</li>
									))}
								</ul>
							)}
						</div>
					))}
				</section>
				<section
                    className="portfolio page-our-focus__portfolio"
                    ref={portfolioRef}
                >
					<div className="portfolio__container">
						<h2 className="portfolio__title title title--white">{our_focus.titlePortfolio}</h2>
						{our_focus.portfolio.length > 0 && (
							<ul className="portfolio__list">
								{our_focus.portfolio.map(item => (
									<li key={item.key} className="portfolio__item">
										<a href={item.button.Link}>
											<h3 className="portfolio__name smallTitle smallTitle--black">{item.title}</h3>
											<span className="portfolio__tag smallTitle">{item.subTitle}</span>
											<p className="portfolio__text smallText smallText--black" dangerouslySetInnerHTML={{__html: item.description}} />
											<span className="portfolio__btn button button--white button--medium">{item.button.Title}</span>
											<div className="portfolio__img">
												<img src={`${domain}${item.logo}`} alt={`${item.title} ${item.subTitle}`} />
											</div>
										</a>
									</li>
								))}
							</ul>
						)}
					</div>
				</section>
			</main>
		</>
	);
};

export default Our_Focus;
